import { SEARCH, SORT } from 'constants/FilterConstants';
import { filterSliceAdapter } from 'modules/global/reducers/filterSliceAdapter';
import { getPersistedFilters } from 'services/StateLoader';
import { createReducer } from 'utils/ReduxUtils';

import * as types from '../../../actionTypes';

/** @typedef {'text' | 'sort'} FilterTagField */
/** @typedef {string | number | Array<string> | Array<number>} FilterValue */
/** @typedef {Record<FilterTagField, FilterValue>} TagsFiltersReducer */

const persistedFilters = getPersistedFilters()?.filters?.tags ?? {};
const emptyState = {
  [SEARCH]: null,
  [SORT]: 'name,ASC',
};

/** @type {import("modules/global/reducers/filterSliceAdapter").FilterAdapter<TagsFiltersReducer>} */
const filterAdapter = filterSliceAdapter(emptyState, persistedFilters);

export default createReducer(filterAdapter.getInitialState(), {
  [types.SET_TAGS_DASHBOARD_FILTER]: filterAdapter.setFilter,
  [types.SET_TAGS_DASHBOARD_FILTERS]: filterAdapter.setFilters,
  [types.CLEAR_TAGS_DASHBOARD_FILTERS]: filterAdapter.resetFilters,
  [types.REMOVE_TAGS_DASHBOARD_FILTER]: filterAdapter.removeFilter,
});
